import config from '@dataroom/config';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';

export const AUTO_SEND_ACCESS_REQUEST = 'AUTO_SEND_ACCESS_REQUEST';
export const AUTO_SEND_FOLLOW = 'AUTO_SEND_FOLLOW';

export const getSetsTitle = (tenant: DataroomTenant) => {
  switch (tenant) {
    case config.verisend.code:
      return 'My VeriSends';
    case config.researchroom.code:
      return 'My Research';
    default:
      return 'My Sets';
  }
};
